import { PaginationFilterRequest } from '@/models/core.model';
import { utcToJSDate } from '@/utils/date-time';
import { UserLookup } from './user.model';

export function pointTransactionFromJson(json: any): PointTransaction {
  return {
    ...json,
    expireTime: utcToJSDate(json.expireTime),
    createdAt: utcToJSDate(json.createdAt),
  } as PointTransaction;
}

export interface PointTransaction {
  id: number;
  userId: number;
  user: UserLookup;
  operationId: string;
  amount: number;
  expireTime?: Date;
  reason: PointTransactionReason;
  note?: string;
  createdAt: Date;
  pointTypeId?: number;
}



export interface ManualGrantPointsRequest {
  userId?: number;
  amount?: number;
  expireTime?: Date;
  note?: string;
  idempotencyKey?: string;
  pointTypeId?: number;
}

export interface ManualDeductPointsRequest {
  userId?: number;
  amount?: number;
  note?: string;
  idempotencyKey?: string;
  pointTypeId?: number;
}

export enum PointTransactionReason {
  SubscriptionGrant = 1000,
  ManualGrant = 1001,
  MarketplaceSale = 1002,
  AccountGrant = 1003,
  AiGenerationRefund = 1004,
  Expired = 2000,
  ManualDeduct = 2001,
  Redeem = 2002,
  MarketplacePurchase = 2003,
  AiGeneration = 2004,
}

export const PointTransactionReasonList = [
  { value: 1000, label: 'Subscription Grant' },
  { value: 1001, label: 'Manual Grant' },
  { value: 1002, label: 'Marketplace Sale' },
  { value: 1003, label: 'Account Grant' },
  { value: 1004, label: 'AI Generation Refund' },
  { value: 2000, label: 'Expired' },
  { value: 2001, label: 'Manual Deduct' },
  { value: 2002, label: 'Redeem' },
  { value: 2003, label: 'Marketplace Purchase' },
  { value: 2004, label: 'AI Generation' },
];

export const EarnReasons = [PointTransactionReason.SubscriptionGrant, PointTransactionReason.ManualGrant, PointTransactionReason.MarketplaceSale, PointTransactionReason.AccountGrant, PointTransactionReason.AiGenerationRefund];
export const SpendReasons = [PointTransactionReason.Expired, PointTransactionReason.ManualDeduct, PointTransactionReason.Redeem, PointTransactionReason.MarketplacePurchase, PointTransactionReason.AiGeneration];

export class PointTransactionPaginationFilter extends PaginationFilterRequest {
  userId?: number;
  reason?: PointTransactionReason;
  onlyEarns?: boolean;
  onlySpends?: boolean;
  date?: string;
  pointTypeId?: number;
}
